var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6774 17.6539L14.6804 3.65846C13.5748 1.44719 10.4192 1.44717 9.3137 3.65846L2.31663 17.6539C1.31937 19.6486 2.76988 21.9954 4.99997 21.9954H18.9941C21.2242 21.9954 22.6747 19.6486 21.6774 17.6539ZM11.1026 4.55282C11.4711 3.81573 12.523 3.81573 12.8915 4.55282L19.8885 18.5483C20.221 19.2132 19.7375 19.9954 18.9941 19.9954H4.99997C4.2566 19.9954 3.7731 19.2132 4.10552 18.5483L11.1026 4.55282ZM11.9935 7.81836C11.3405 7.81836 10.8187 8.38466 10.8448 9.0649L11.0602 13.6806C11.0803 14.2029 11.4922 14.6155 11.9935 14.6155C12.4948 14.6155 12.9067 14.2029 12.9267 13.6806L13.1422 9.0649C13.1683 8.38467 12.6464 7.81836 11.9935 7.81836ZM10.6474 17.4035C10.6474 16.6284 11.2501 16 11.9935 16C12.7369 16 13.3396 16.6284 13.3396 17.4035C13.3396 18.1786 12.7369 18.807 11.9935 18.807C11.2501 18.807 10.6474 18.1786 10.6474 17.4035Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangle);
export default __webpack_public_path__ + "static/media/exclamation_triangle.f5e7af3fef9b81de0d78628b64f86995.svg";
export { ForwardRef as ReactComponent };